import DashboardLearningItem from "./DashboardLearningItem";

export default DashboardLearningItem;